import { boolean, optionalBoolean, string, uuid, z, zodLess, ZodLessInfer } from '@kaiizen/zod-less';

export const ApiOrgSchema = zodLess({
  id: uuid,
  name: string,
  /** Live orgs are counted in billing and cost reports. Only super admins can change it. */
  isLive: boolean,
});
export const AllProductSupplierOrgsSchema = zodLess({
  homeDepot: ApiOrgSchema,
});
export type AllProductSupplierOrgs = ZodLessInfer<typeof AllProductSupplierOrgsSchema>;
export type ApiOrg = ZodLessInfer<typeof ApiOrgSchema>;

export const ORG_NAME_MAX_LENGTH = 32;

/** An org name as someone enters it: trimmed, then 1 to `ORG_NAME_MAX_LENGTH` characters. */
export const ApiOrgNameSchema = z.string().trim().min(1).max(ORG_NAME_MAX_LENGTH);

export const isValidOrgName = (name: string) => ApiOrgNameSchema.safeParse(name).success;

export const ApiCreateOrgSchema = zodLess({
  name: ApiOrgNameSchema,
  isLive: optionalBoolean,
});
export type ApiCreateOrg = ZodLessInfer<typeof ApiCreateOrgSchema>;

export const ApiUpdateOrgSchema = zodLess({
  name: ApiOrgNameSchema.optional(),
  isLive: optionalBoolean,
});
export type ApiUpdateOrg = ZodLessInfer<typeof ApiUpdateOrgSchema>;

export const getCurrentOrgQueryKey = (token?: string | null) => `currentOrg/${token}`;
